import React from 'react'
import { Modal } from '@taglivros/oef_componentes'
import { bool, func } from 'prop-types'
import { navigate } from '@reach/router'
import BannerIneditos from '../../../../assets/imagens/banner-ineditos.png'
import BannerCuradoria from '../../../../assets/imagens/banner-curadoria.png'
import { ROUTE_BASEPATH } from '../../../../constants'
import styled from 'styled-components'

const Titulo = styled.h2`
  color: #343a4f;
  margin: 12px 0;
`

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
  align-items: center;
  img {
    padding-top: 24px;
    width: 70%;
    cursor: pointer;
    padding-bottom: 24px;
  }
  span {
    cursor: pointer;
    padding-top: 24px;
    font-size: 20px;
    color: #009bbf;
    font-weight: 700;
    text-decoration: underline;
    padding-bottom: 24px;
  }
`

const ComboRenovacaoModal = ( {
  open,
  curadoriaPodeRenovar,
  ineditosPodeRenovar,
  onShowModal,
} ) => {
  const baseUrl = () => {
    if ( ROUTE_BASEPATH === '/' ) {
      return '/'
    } else {
      return `${ROUTE_BASEPATH}/`
    }
  }

  const renderCuradoriaButton = () => {
    return (
      <img
        alt="banner"
        onClick={ () => navigate( `${baseUrl()}curadoria/plano/renovar-plano/selecionar-entrega` ) }
        src={ BannerCuradoria }
        width="100%"
      />
    )
  }

  const renderIneditosButton = () => {
    return (
      <img
        alt="botao-ineditos"
        onClick={ () => navigate( `${baseUrl()}ineditos/plano/renovar-plano/selecionar-entrega` ) }
        src={ BannerIneditos }
        width="100%"
      />
    )
  }

  const renderAllButons = () => {
    return (
      <>
        {renderCuradoriaButton()}

        {renderIneditosButton()}
      </>
    )
  }

  const render = () => {
    if ( curadoriaPodeRenovar && ineditosPodeRenovar ) {
      return renderAllButons()
    }
    if ( curadoriaPodeRenovar ) {
      return renderCuradoriaButton()
    }
    if ( ineditosPodeRenovar ) {
      return renderIneditosButton()
    }
  }

  return (
    <Modal
      altura="auto"
      onShowModal={ onShowModal }
      show={ open }
    >
      <ModalWrapper>
        <Titulo>Escolha qual plano você deseja renovar: </Titulo>

        {render()}
      </ModalWrapper>
    </Modal>
  )
}

ComboRenovacaoModal.propTypes = {
  'curadoriaPodeRenovar': bool.isRequired,
  'ineditosPodeRenovar': bool.isRequired,
  'onShowModal': func.isRequired,
  'open': bool.isRequired
}

export default ComboRenovacaoModal
